var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videos"},_vm._l((_vm.question),function(item,index){return _c('question-answer',{key:index,staticClass:"item",attrs:{"question-item":item,"question-index":index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }